import { Link } from "react-router-dom";

// Glowing pill button.
// variant: primary (brand gradient) | ghost (glass) | soft (brand tint)
// Use `href` for external links (opens new tab), `to` for internal routes.
export default function GlowButton({ to, href, external, children, variant = "primary", className = "", icon, ...props }) {
  const base = "group relative inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-semibold transition-all duration-300 will-change-transform";
  const styles = {
    primary: "text-white bg-brand-gradient hover:glow-brand hover:-translate-y-0.5",
    ghost: "text-slate-800 glass hover:bg-white/90 hover:-translate-y-0.5",
    soft: "text-brand bg-brand-soft hover:-translate-y-0.5",
  }[variant];
  const cls = `${base} ${styles} ${className}`;
  const inner = (<><span>{children}</span>{icon}</>);

  if (href) {
    const ext = external ?? /^https?:\/\//.test(href);
    return <a href={href} className={cls} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})} {...props}>{inner}</a>;
  }
  if (to) return <Link to={to} className={cls} {...props}>{inner}</Link>;
  return <button className={cls} {...props}>{inner}</button>;
}
